










import Vue, { PropType } from 'vue';
import { tConvert, convertDateToAmericanFormat } from '../../lib/utils';

export default Vue.extend({
    props: {
        ridesData: {
            type: Array as PropType<object>,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    components: {},
    data() {
        return {
            headers: [
                { text: 'Date', value: 'date', width: 100 },
                { text: 'Route', value: 'routeName' },
                {
                    text: 'Planned Departure',
                    value: 'plannedDeparture',
                    sortable: false,
                    width: 110,
                },
                {
                    text: 'Boarded',
                    value: 'boardedPassengers',
                    width: 110,
                },
                {
                    text: 'Non Boarded',
                    value: 'nonBoardedPassengers',
                    width: 110,
                },
                {
                    text: 'Available Seats',
                    value: 'seats',
                    width: 110,
                },
            ],
            data: [],
        };
    },
    created() {
        this.data = this.ridesData as any;
    },
    methods: {
        tConvert,
        convertDateToAmericanFormat,
    },
    watch: {
        ridesData: {
            deep: true,
            handler(newVal) {
                this.data = newVal
                    .map((r: any) => {
                        r.seats = r.extraDetails.rideAvailableSeats;
                        return r;
                    })
                    .sort((a: any, b: any) => (a.date > b.date ? -1 : 1));
            },
        },
    },
});
